import React from 'react';
import { MdArrowBack } from 'react-icons/md';
import { useShell } from './ChatShell';

/**
 * The way out of a pane on a phone.
 *
 * Below the phone breakpoint a pane covers the conversation list entirely, so
 * every one of them needs a way back to it — without this, selecting a call, a
 * notification or a settings section was a dead end with no route to undo it.
 *
 * Rendered only on a phone: at any width where the list is already beside the
 * pane, a back arrow points at something that never left the screen.
 *
 * `onBack` overrides the shell's own close for the panes that mean something
 * different by "back" — a settings sub-section returns to its section, not to
 * the settings list.
 */
const PaneBack = ({ onBack, label = 'Back' }) => {
  const { isPhone, closePane } = useShell();

  if (!isPhone) return null;

  return (
    <button
      type="button"
      className="pane-back"
      title={label}
      aria-label={label}
      onClick={onBack || closePane}
    >
      <MdArrowBack size={20} />
    </button>
  );
};

export default PaneBack;
